import { PropsWithChildren } from 'react';

export function ModalTitle({ children }: PropsWithChildren) {
  return (
    <h3 className="text-[24px] font-medium leading-6 text-gray-900">
      {children}
    </h3>
  );
}
